import { useRef } from 'react';

// Helper to normalize and detect completed status (case-insensitive)
const isCompleted = (s) => typeof s === 'string' && ['completed', 'need_attention'].includes(s.toLowerCase());

export default function useExpenseMatching(t) {
  // Track which expense checksums have already been processed to avoid duplicate PUTs
  const processedChecksumsRef = useRef(new Set());

  const hasUnprocessedCompletedExpenses = (statement) => {
    if (!statement?.expenses?.length) return false;
    return statement.expenses.some((e) => isCompleted(e.status) && e.checksum && !processedChecksumsRef.current.has(e.checksum));
  };

  return { hasUnprocessedCompletedExpenses };
}
